import { Component } from "@angular/core";
import * as differenceInCalendarDays_ from "date-fns/difference_in_calendar_days";
import { FieldType, KreFormCommonService } from "@kre-form/core";
import * as moment_ from "moment";
import { FieldWrapper, FormGlobalService } from "@kre-form/core";

const moment = moment_;
const differenceInCalendarDays = differenceInCalendarDays_;

@Component({
  selector: "krefield-datetime",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <input nz-input disabled />
      </div>
    </ng-container>

    <ng-template #other>
      <ng-container *ngIf="editor === true">
        <ng-container [ngSwitch]="showType">
          <ng-container *ngSwitchCase="'datetime'">
            <nz-date-picker
              nzShowTime
              [nzShowTime]="{ nzFormat: 'HH:mm' }"
              nzFormat="yyyy/MM/dd HH:mm"
              [formControl]="formControl"
              [kreFormAttributes]="field"
              [class.is-invalid]="showError"
              [nzDisabledDate]="disabledDate"
              [nzDisabledTime]="disabledDateTime"
              [nzPlaceHolder]="to.placeholder || undefined"
              (nzOnOpenChange)="nzOnOpenChange($event, true)"
            ></nz-date-picker>
          </ng-container>
          <ng-container *ngSwitchCase="'date'">
            <nz-date-picker
              nzFormat="yyyy/MM/dd"
              [formControl]="formControl"
              [kreFormAttributes]="field"
              [nzDisabledDate]="disabledDate"
              [class.is-invalid]="showError"
              [nzShowToday]="showToday"
              [nzPlaceHolder]="to.placeholder || undefined"
              (nzOnOpenChange)="nzOnOpenChange($event, false)"
            ></nz-date-picker>
          </ng-container>
          <ng-container *ngSwitchCase="'year'">
            <nz-year-picker
              nzFormat="yyyy"
              [formControl]="formControl"
              [kreFormAttributes]="field"
              [class.is-invalid]="showError"
              [nzPlaceHolder]="to.placeholder || undefined"
              (nzOnOpenChange)="nzOnOpenChange($event, false)"
            ></nz-year-picker>
          </ng-container>
          <ng-container *ngSwitchCase="'month'">
            <nz-month-picker
              nzFormat="yyyy/MM"
              [formControl]="formControl"
              [kreFormAttributes]="field"
              [class.is-invalid]="showError"
              [nzPlaceHolder]="to.placeholder || undefined"
              (nzOnOpenChange)="nzOnOpenChange($event, false)"
            ></nz-month-picker>
          </ng-container>
          <ng-container *ngSwitchCase="'time'">
            <nz-time-picker
              nzFormat="HH:mm"
              [formControl]="formControl"
              [kreFormAttributes]="field"
              [class.is-invalid]="showError"
              [nzDisabledHours]="disabledHours"
              [nzDisabledMinutes]="disabledMinutes"
              (nzOpenChange)="nzOnOpenChange($event, true)"
              [nzPlaceHolder]="to.placeholder || undefined"
              nzClearText=""
              [nzPopupClassName]="field.className"
            ></nz-time-picker>
          </ng-container>
          <ng-container *ngSwitchDefault></ng-container>
        </ng-container>
      </ng-container>

      <div class="fieldtext" *ngIf="editor === false">
        {{ getText() }}
      </div>
    </ng-template>
  `,
})
export class KreFormFieldDateTime extends FieldType {
  constructor(
    private globalService: FormGlobalService,
    private commonService: KreFormCommonService
  ) {
    super();
  }

  /**
   *
   * @param e
   * @param global 该变量是用来做之前的兼容，具体用来干什么 需要看外部的调用
   */
  nzOnOpenChange(e: any, global: boolean) {
    if (global == true) {
      if (
        !!this.field &&
        !!this.field.templateOptions &&
        this.field.templateOptions.enableInterface
      ) {
        this.globalService.notifyDataChanged("DateTimeClick", {
          rdm: Math.random(),
          config: this.field,
          state: e,
        });
      }
    }

    if (
      e == false &&
      this.to != undefined &&
      this.to != null &&
      this.to.blur != undefined &&
      this.to.blur != null
    ) {
      this.to.blur(this.field, null);
    }
  }

  //datetime date month year time
  get format() {
    let result = "yyyy/MM/dd HH:mm";
    if (
      this.to!["format"] != undefined &&
      this.to!["format"] != null &&
      this.to!["format"] != ""
    ) {
      result = this.to!["format"];
    }
    return result;
  }
  get showType() {
    let result = "datetime";
    if (
      this.to!["type"] != undefined &&
      this.to!["type"] != null &&
      this.to!["type"] != ""
    ) {
      result = this.to!["type"].toLowerCase();
    }
    return result;
  }

  getText() {
    let result = "";
    if (
      this.to!.type === undefined ||
      this.to!.type === null ||
      this.to!.type === ""
    ) {
      this.to!.type = "datetime";
    }
    if (
      this.model != undefined &&
      this.model != null &&
      this.field != undefined &&
      this.field != null &&
      this.field.key != undefined &&
      this.field.key != null &&
      this.model[this.field.key] != undefined &&
      this.model[this.field.key] != null &&
      this.model[this.field.key] != ""
    ) {
      if (moment(this.model[this.field.key]).isValid()) {
        const date: any = this.model[this.field.key];
        switch (this.to!.type) {
          case "datetime":
            result = moment(date).format("YYYY/MM/DD HH:mm");
            break;
          case "date":
            result = moment(date).format("YYYY/MM/DD");
            break;
          case "year":
            result = moment(date).format("YYYY");
            break;
          case "month":
            result = moment(date).format("YYYY/MM");
            break;
          case "time":
            result = moment(date).format("HH:mm");
            break;
        }
      }
    }
    return result;
  }
  disabledDate = (current: Date): boolean => {
    if (!!this.to!.maxDate && !!this.to!.minDate) {
      return (
        differenceInCalendarDays(current, new Date(this.to!.maxDate)) > 0 ||
        differenceInCalendarDays(current, new Date(this.to!.minDate!)) < 0
      );
    } else if (!!this.to!.maxDate && !this.to!.minDate) {
      return differenceInCalendarDays(current, new Date(this.to!.maxDate)) > 0;
    } else if (!this.to!.maxDate && !!this.to!.minDate) {
      return differenceInCalendarDays(current, new Date(this.to!.minDate)) < 0;
    } else {
      return false;
    }
  };

  disabledDateTime = (e: Date) => {
    let nzDisabledHours: number[] = [];
    let nzDisabledMinutes: number[] = [];

    if (!!this.to!.maxDate && !!this.to!.minDate) {
      if (differenceInCalendarDays(e, new Date(this.to!.minDate)) === 0) {
        nzDisabledHours = this.range(-1, new Date(this.to!.minDate).getHours());

        if (!!e && new Date(this.to!.minDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            -1,
            new Date(this.to!.minDate).getMinutes()
          );
        }
      }
      if (differenceInCalendarDays(e, new Date(this.to!.maxDate)) === 0) {
        nzDisabledHours = [
          ...nzDisabledHours,
          ...this.range(new Date(this.to!.maxDate).getHours() + 1, 24),
        ];

        if (!!e && new Date(this.to!.maxDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = [
            ...nzDisabledMinutes,
            ...this.range(new Date(this.to!.maxDate).getMinutes(), 60),
          ];
        }
      }
    } else if (!!this.to!.maxDate && !this.to!.minDate) {
      if (
        !!e &&
        differenceInCalendarDays(e, new Date(this.to!.maxDate)) === 0
      ) {
        nzDisabledHours = this.range(
          new Date(this.to!.maxDate).getHours() + 1,
          24
        );
        if (!!e && new Date(this.to!.maxDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            new Date(this.to!.maxDate).getMinutes(),
            60
          );
        }
      }
    } else if (!this.to!.maxDate && !!this.to!.minDate) {
      if (
        !!e &&
        differenceInCalendarDays(e, new Date(this.to!.minDate)) === 0
      ) {
        nzDisabledHours = this.range(0, new Date(this.to!.minDate).getHours());
        if (!!e && new Date(this.to!.minDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            -1,
            new Date(this.to!.minDate).getMinutes()
          );
        }
      }
    }
    return {
      nzDisabledHours: () => nzDisabledHours,
      nzDisabledMinutes: () => nzDisabledMinutes,
      nzDisabledSeconds: () => [],
    };
  };

  disabledHours = () => {
    let nzDisabledHours: number[] = [];

    if (!!this.to!.maxDate && !!this.to!.minDate) {
      nzDisabledHours = this.range(-1, new Date(this.to!.minDate).getHours());
      nzDisabledHours = nzDisabledHours.concat(
        this.range(new Date(this.to!.maxDate).getHours() + 1, 24)
      );
    } else if (!!this.to!.maxDate && !this.to!.minDate) {
      nzDisabledHours = this.range(
        new Date(this.to!.maxDate).getHours() + 1,
        24
      );
    } else if (!this.to!.maxDate && !!this.to!.minDate) {
      nzDisabledHours = this.range(0, new Date(this.to!.minDate).getHours());
    }
    return nzDisabledHours;
  };

  disabledMinutes = (e: Date) => {
    let nzDisabledMinutes: number[] = [];
    if (!!this.to!.maxDate && !!this.to!.minDate) {
      if (differenceInCalendarDays(e, new Date(this.to!.minDate)) === 0) {
        if (!!e && new Date(this.to!.minDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            -1,
            new Date(this.to!.minDate).getMinutes()
          );
        }
      }
      if (differenceInCalendarDays(e, new Date(this.to!.maxDate)) === 0) {
        if (!!e && new Date(this.to!.maxDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            new Date(this.to!.maxDate).getMinutes(),
            60
          );
        }
      }
    } else if (!!this.to!.maxDate && !this.to!.minDate) {
      if (
        !!e &&
        differenceInCalendarDays(e, new Date(this.to!.maxDate)) === 0
      ) {
        if (!!e && new Date(this.to!.maxDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            new Date(this.to!.maxDate).getMinutes(),
            60
          );
        }
      }
    } else if (!this.to!.maxDate && !!this.to!.minDate) {
      if (
        !!e &&
        differenceInCalendarDays(e, new Date(this.to!.minDate)) === 0
      ) {
        if (!!e && new Date(this.to!.minDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            -1,
            new Date(this.to!.minDate).getMinutes()
          );
        }
      }
    }

    return nzDisabledMinutes;
  };
  // differenceInCalendarDays(e: Date | null, date: Date): number {
  //   if (!!e) {
  //     return e.getDate() - date.getDate();
  //   } else {
  //     return 0;
  //   }
  // }

  range(start: number, end: number): number[] {
    const result: number[] = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  get showToday(): boolean {
    if (typeof this.to.today === "undefined") {
      return true;
    }
    return !!this.to.today;
  }
}
